// NV-7778: We share this css between react component and server side rendered component
import '../../../../components/submit-indicators/submit-indicators.scss';
import { SanitizerService } from '../../../services/sanitizer.service';

function SubmitFailed({ failedText }: { failedText: string }) {
  return (
    <div className="submit-failed">
      <div className="circle__box mt-0 mb-3 mx-auto">
        <div className="circle__wrapper circle__wrapper--right">
          <div className="circle__whole circle__right"></div>
        </div>
        <div className="circle__wrapper circle__wrapper--left">
          <div className="circle__whole circle__left"></div>
        </div>
        <div className="circle__cross"></div>
        <div className="circle__eyes"></div>
        <div className="circle__mouth-container">
          <div className="circle__mouth"></div>
        </div>
      </div>

      <div className="submit-failed__error-info mb-4">
        <div dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(failedText) }}></div>
      </div>
    </div>
  );
}

export default SubmitFailed;
